import React from 'react';
import { fromInfo } from '../../../../_providers/Translation';

function HelpInfo() {
    return (
        <div>
            {fromInfo('banktransactions')}
        </div>
    )
}

export default HelpInfo;